<header class="header">
  <div class="chat-header-main">
    <div class="breadcrumb">
      <button
        cuiButton
        variant="plain"
        type="button"
        aria-label="Show chat overview"
        (click)="showOverview.emit()">
        <span class="material-symbols-outlined" aria-hidden="true">forum</span>
        <span>Chats</span>
      </button>
      @if (session()) {
        <span class="chevron material-symbols-outlined" aria-hidden="true">chevron_forward</span>
      }
    </div>
    @if (session(); as activeSession) {
      <div class="chat-title-actions">
        @if (fullscreen()) {
          <span class="material-symbols-outlined chat-title-icon" aria-hidden="true">chat</span>
        }
        <h1 class="title">{{ activeSession.title || 'New chat' }}</h1>
        @if (fullscreen()) {
          <time class="chat-date" [attr.datetime]="activeSession.createdAt">
            {{ formatDateTime(activeSession.createdAt) }}
          </time>
        }
        <button
          cuiButton
          square
          variant="plain"
          type="button"
          aria-label="Chat actions"
          [cuiDropdownTriggerFor]="chatMenu">
          <span class="material-symbols-outlined" aria-hidden="true">more_vert</span>
        </button>
        <cui-dropdown #chatMenu>
          <button
            cuiButton
            cdkMenuItem
            class="cui-dropdown__item"
            variant="plain"
            type="button"
            (click)="chatMenu.close(); deleteSession.emit(activeSession)">
            <span class="material-symbols-outlined" aria-hidden="true">delete</span>
            Delete Chat
          </button>
        </cui-dropdown>
      </div>
    }
  </div>
  <div class="chat-header-actions">
    <button
      cuiButton
      variant="plain"
      type="button"
      aria-label="Start new chat"
      (click)="newChat.emit()">
      <span class="material-symbols-outlined" aria-hidden="true">add</span>
      <span>New Chat</span>
    </button>
    <button
      cuiButton
      square
      variant="plain"
      type="button"
      aria-label="Open chat fullscreen"
      (click)="enterFullscreen.emit()">
      <span class="material-symbols-outlined" aria-hidden="true">fullscreen</span>
    </button>
  </div>
</header>
